export default "__VITE_ASSET__t73nL0al__"